<ng-container *ngIf="(loggedInUserRole == 'Employee' || loggedInUserRole == 'Manager') && !isShowMD">
  <ion-content class="container">
    <div class="pt-10">
      <ion-row>
        <ion-col size-sm="10" size-md="9" size-lg="8" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="cardBox p-10">
            <ion-row class="borderbottomForTab">
              <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10">
                <div>
                  <div class="formLabelSemiBoldfs14 mt-10">Hey, {{loggedInUserName}}!
                  </div>
                </div>
              </ion-col>
              <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10">
                <div>
                  <ion-row>
                    <div class="formLabelSemiBoldfs12 mt-10 mr-10">Year
                    </div>
                    <mat-form-field class="w150 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                        (selectionChange)="vpPeriodsByUser()">
                        <mat-option *ngFor="let item of companyYears" [value]="item.year">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-row>
                </div>
              </ion-col>
              <ion-col size-sm="10" size-md="9" size-lg="4" size-xs="10" class="mb-10">
                <div>
                  <ion-row>
                    <div class="formLabelSemiBoldfs12 mt-10 mr-10">Period
                    </div>
                    <mat-form-field class="w250 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" [(ngModel)]="frequencyPeriod"
                        (selectionChange)="approvedVPPeriods()">
                        <mat-option *ngFor="let month of variablePeriodFrquencyForEmp" [value]="month">
                          {{ month }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>

            <ion-row *ngIf="dateOfVpEmployee!=null">
              <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10">
                <div class="m-20">
                  <img src="././assets/icon/variable_pay.png">
                </div>
              </ion-col>
              <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10">
                <div class="mb-10 mt-10">
                  <div class="font_regular fs-12">{{dateOfVpEmployee | date:'dd-MM-yyyy'}}</div>
                </div>

                <div class="mb-10">
                  <p class="font_regular fs-12">I am pleased to inform you that, in recognition of your exceptional
                    <br /> performance and the team's achievements, you have been awarded <br /> Variable Pay for
                    {{frequencyPeriod}}.
                  </p>
                </div>

                <div class="mb-10 mt-20">
                  <div [style.color]="buttonColorName" class="font_bold text_decoration fs-12 cp"
                    (click)="onClickEmpViewVariablePayLetter()">View Variable Pay Letter</div>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </ion-content>
</ng-container>

<!-- <ng-template> -->
  <ion-content class="container" *ngIf="loggedInUserRole == 'HOD' || loggedInUserRole == 'Super Admin' ||
  loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'HR Admin' || isShowMD">
    <ion-row *ngIf="!router.url.includes('Setup')">
      <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
        <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
          <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
            (selectedTabChange)="tabTypeChanged($event)">
            <mat-tab label="Dashboard">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-5">
                    speed
                  </span>Dashboard</span>
              </ng-template>
            </mat-tab>
            <mat-tab label="Variable Pay Input">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-5">
                    group
                  </span>Variable Pay Input</span>
              </ng-template>
            </mat-tab>
            <mat-tab label="Variable Pay Summary">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-5">
                    ads_click
                  </span>Variable Pay Summary
                </span>
              </ng-template>
            </mat-tab>
            <mat-tab label="Variable Pay Report">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-5">
                    description
                  </span>Reports</span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
      <div
        *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || isShowMD)">

      </div>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="borderbottomForTab pl-10 pt-10 pr-10"
        *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || isShowMD)">
        <div class="center-content float-right">
          <div>
            <span class="cp fs-14 link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
              <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
          </div>
          <div>
            <button type="button" class="add_btn fs-14 float-right center-content mr-5"
              [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
              <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!-- ---------------------------- Setup Variable Pay ---------------------------------- -->

    <div class="modal fade" [style.display]="showSetupPopup? 'block' : 'none'">
      <div class="modal-dialog">
        <div class="modal-content">
          <ion-row class="p-0  headerBreadcrumb">
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
              <div class="d-flex headerBreadcrumb">
                <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBreadcrumPMS()">
                <label class="font_semibold fs-18 ml-10 mt-5 black_color">
                  <span class="cp" (click)="onClickBreadcrumPMS()">Variable Pay</span> / <span
                    [style.color]="buttonColorName">Setup</span></label>
              </div>
            </ion-col>
            <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="text-right">
              <div class="d-inline-flex p-5">
                <div class="center-content fs-14 font_regular mr-15">Variable Pay Policy -</div>
                <div class="cp text-center font_regular mr-15">
                  <span class="material-icons fs-18" (click)="onClickUploadfile('uploadfile')">upload_file</span>
                  <div class="fs-12" (click)="onClickUploadfile('uploadfile')"><u>Upload</u></div>
                </div>
                <div class="cp text-center font_regular mr-15" (click)="getVPPolicyFile()">
                  <span class="material-icons fs-18">download</span>
                  <div class="fs-12"><u>Download</u></div>
                </div>
                <button type="button" class="add_btn btn_blue fs-14 mr-10"
                  (click)="onClickEmailContentBtn('emailContent')">
                  Email Content</button>
                <button type="button" class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName"
                  (click)="onClickVariablePaytLetterBtn('incrementLetter')">Variable Pay Letter</button>

                <!-- <span class="cp fs-14 link font_regular center-content mr-10" (click)="onClickLogs('Increment')">
                    <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span> -->
              </div>
            </ion-col>
          </ion-row>
        </div>


        <div class="modal-body p-20">

          <div class="cardBox mb-20">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Setup</div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                  <div class="formLabelSemiBoldfs14 mb-5">Fiscal year - <span [style.color]="buttonColorName">
                    {{sharedService.transformYearToFyFormat(selectedYear)}}</span>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="2" size-xs="3">
                  <div class="formLabelSemiBoldfs14 mb-5">Year<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(value)]="selectedYear"
                      (selectionChange)="setUpYearChnage($event);onYearChange();getVPCurrentYearFrequeny()">
                      <mat-option *ngFor="let item of companyYears" [value]="item.year">
                        {{ sharedService.transformYearToFyFormat(item.year) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                  <div class="formLabelSemiBoldfs14 mb-5">Frequency<span class="red-cl">&nbsp;*</span></div>
                  <!-- <div *ngIf="!isSelectedYearIsSameYeartoCurrentYear && isVPSetupDone" class="inputBoxDisabled opacity5">
                    {{setupFrequency}}
                </div> -->
                <div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Frequency" [(ngModel)]="setupFrequency" [disabled]="isVPSetupDone"
                      (selectionChange)="updatePeriodOptions($event);clearCutOffDays();getPrevYearSetupVP();">
                      <mat-option *ngFor="let frequency of filteredFrequencies" [value]="frequency">
                        {{ frequency }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                </ion-col>

                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                  <div class="formLabelSemiBoldfs14 mb-5">{{ frequencyName === 'Semi_Annually' ? 'Semi-Annually' :
                    setupFrequency }}<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Period"
                      (selectionChange)="onPeriodChange($event);clearCutOffDays();" [(ngModel)]="frequencyPeriod">
                      <mat-option *ngFor="let months of setupMonths" [value]="months">
                        {{ months }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>

                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                  <ion-row>
                    <div class="formLabelSemiBoldfs14 mb-5">
                      Cut off Date for VP Eligibility<span class="red-cl">&nbsp;*</span>
                    </div>

                    <!-- Info icon with a tooltip triggered on click -->
                    <span class="material-icons custom-icon" (mouseenter)="showInfo = true"
                      (mouseleave)="showInfo = false">
                      info
                    </span>
                    <div class="tooltip-box fs-12" *ngIf="showInfo">
                      Enter cutoff day of {{frequencyName}} for VP eligibility out of {{tooltipDynamic()}} days.
                    </div>
                  </ion-row>
                  <mat-form-field class="w-20 mat-height40 mat-input-style">
                    <input matInput placeholder=""  [ngClass]="{'disableBtn':isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear}" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" 
                    class="font_regular text-center"
                      (ngModelChange)="calculateCutoffDate($event)" [(ngModel)]="cutOffDate" />
                  </mat-form-field>
                  <span class="days_remain">out of {{tooltipDynamic()}} days</span>
                  <img class="calendar" src="././assets/icon/calendar.svg" />
                  <span class="days_remain" [style.color]="buttonColorName">{{cutOffDateForVariablepay ?
                    cutOffDateForVariablepay : 'NA'}}</span>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="6" size-xs="3">
                  <div class="formLabelSemiBoldfs14 mb-5">Variable Pay<span class="red-cl">&nbsp;*</span>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="p-0">
                <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select [attr.readonly]="isVariablePayApproved ? false: true" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" placeholder="From Month" (selectionChange)="onFromMonthChange()"
                      [(ngModel)]="fromMonth">
                      <mat-option *ngFor="let fromMonth of getMonthsToVariablePay" [value]="fromMonth">
                        {{ fromMonth }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select [attr.readonly]="isVariablePayApproved ? false: true" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" placeholder="To Month" [(ngModel)]="toMonth">
                      <mat-option *ngFor="let toMonth of toMonthsVariablePay" [value]="toMonth">
                        {{ toMonth }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                  <div class="d-flex">
                    <button type="button" class="back_btn" (click)="onClickBreadcrumPMS()">Back</button>
                    <button type="button" class="add_btn fs-14 ml-10" 
                    [ngClass]="{'disableBtn':isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear}" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear"  
                    (click)="setUpVariableCutOff()"
                      [style.background-color]="buttonColorName">Save</button>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </div>


          <!-- Score -->

          <div class="cardBox mb-20" *ngIf="setupFrequency==='Annually'">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Score to final score converter
                    <span [style.color]="buttonColorName">(Individual Score + Individual competency)</span>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <div class="setUptable-container">
                <table class="hover mb-5">
                  <thead class="bg-gray">
                    <tr>
                      <th class="fs-14 font_bold cl-black">Band</th>
                      <th class="fs-14 font_bold cl-black">Individual KPI score wt.</th>
                      <th class="fs-14 font_bold cl-black">Individual competency wt.</th>
                      <th class="fs-14 font_bold cl-black">Total weightage</th>
                      <th class="fs-14 font_bold cl-black" *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear"></th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let item of variableIndivaidualScoreData; let rowId = index">
                      <td class="fs-14 font_regular">
                        <span class="font_bold">{{item.band}}</span>
                      </td>

                      <!-- <div formArrayName="kpiRows"> -->

                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput placeholder="Type here" class="font_regular" type="number"
                            [(ngModel)]="item.individualKpiScoreWeightage"
                            (ngModelChange)="IndividualTotalWeightage(item)"
                            [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" />
                        </mat-form-field>
                        <label *ngIf="isInValidMaxIndividualKpi && editedIndividualScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Enter Individual KPI score weightage is less than 100
                        </label>
                        <label *ngIf="isInValidMinIndividualKpi && editedIndividualScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Enter Individual KPI score weightage is more than 0
                        </label>
                      </td>
                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input [(ngModel)]="item.individualCompetencyWeightage" type="number"
                            (ngModelChange)="IndividualTotalWeightage(item)"
                            [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled" matInput
                            placeholder="Type here" class="font_regular">
                        </mat-form-field>
                        <label *ngIf="isInValidMaxIndividualCompetency && editedIndividualScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Enter Individual KPI score weightage is less than 100
                        </label>
                        <label *ngIf="isInValidMinIndividualCompetency && editedIndividualScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Enter Individual KPI score weightage is more than 0
                        </label>
                      </td>
                      <td class="fs-14 font_regular tableDisableTd">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <!-- <input readonly [(ngModel)]="item.totalWeightage" [disabled]="editedItemId !== item.id && !isFormDisabled"
                                matInput placeholder="Total Weightage" class="font_regular"> -->
                          <input readonly [(ngModel)]="item.totalWeightage" type="number" matInput placeholder=""
                            class="font_regular">
                        </mat-form-field>
                        <label *ngIf="IsIndividualTotalWeightage && editedIndividualScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Individual KPI score weightage is not equal to 100
                        </label>
                      </td>

                      <td *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear">
                        <!-- <div class="d-flex" *ngIf="editedItemId === item.id">
                          <img (click)="isClickEdit(item.id)" *ngIf="editedItemId !== item.id" class="ml-5 cp imgEdit"
                            title="Edit" src="././assets/icon/edit.png">
                          <span (click)="getScoreToFinalConverterIndividual()" *ngIf="editedItemId === item.id"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <span *ngIf="editedItemId === item.id"
                            (click)="onSaveIndividualScoreToFinalScoreConverter(item)"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div> -->
                        <div class="d-flex">
                          <img (click)="onClickIndividualScoreEdit(rowId)" *ngIf="editedIndividualScoreId !== rowId"
                            class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                          <span (click)="closeIndividualScore()"
                            *ngIf="editedIndividualScoreId === rowId && onCheckIconView"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <span
                            *ngIf="editedIndividualScoreId === rowId && onCheckIconView && item.totalWeightage === 100"
                            (click)="onSaveIndividualScoreToFinalScoreConverter(item)"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div>
                      </td>

                      <!-- </div> -->

                      <!-- <td>
                        <div class="d-flex">
                          <img (click)="isClickEdit(item.id)" *ngIf="editedItemId !== item.id" class="ml-5 cp imgEdit"
                            title="Edit" src="././assets/icon/edit.png">
                          <span (click)="getScoreToFinalConverterIndividual()"
                            *ngIf="editedItemId === item.id && onCheckIconView"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <span *ngIf="editedItemId === item.id && onCheckIconView" (click)="onsaveVariablePayScore()"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Score 1 -->

          <div class="cardBox mb-20">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Score to final score converter
                    <span [style.color]="buttonColorName">(Individual Score + Dept Score + Company Score)</span>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <div class="setUptable-container">
                <table class="hover mb-5">
                  <thead class="bg-gray">
                    <tr>
                      <th class="fs-14 font_bold cl-black">Band</th>
                      <th class="fs-14 font_bold cl-black">{{setupFrequency === 'Annually' ? 'Individual KPI +
                        Competency wt.' : 'Individual KPI'}}</th>
                      <th class="fs-14 font_bold cl-black">Dept KPI score</th>
                      <th class="fs-14 font_bold cl-black">Co. KPI Score weightage</th>
                      <th class="fs-14 font_bold cl-black">Total weightage</th>
                      <th class="fs-14 font_bold cl-black" *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear"></th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let item of individualCompanyScore; let rowId = index">
                      <td class="fs-14 font_regular">
                        <span class="font_bold">{{item.band}}</span>
                      </td>
                      <!-- <label *ngIf="InvalidIndividualCompetencyMaxTW && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            Individual KPI and Competency weightage is less than 100
                          </label>
                          <label *ngIf="InvalidIndividualCompetencyMinTW && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            Individual KPI and Competency weightage is more than 0
                          </label> -->

                      <!-- <td class="fs-14 font_regular">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input class="font_regular" placeholder="Type text here" matInput>
                          </mat-form-field>
                          <label *ngIf="InvalidDepthKpiMaxScore && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            Depth kpi score is less than 100
                          </label>
                          <label *ngIf="InvalidDepthKpiMinScore && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            Depth kpi score is more than 0
                          </label>
                        </td>
                        <td class="fs-14 font_regular">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input class="font_regular" placeholder="Type text here" matInput>
                          </mat-form-field>
                          <label *ngIf="InvalidcompanyKpiScoreMaxScore && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            company kpi score is less than 100
                          </label>
                          <label *ngIf="InvalidcompanyKpiScoreMinScore && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            company kpi score is more than 0
                          </label>
                        </td>
                        <td class="fs-14 font_regular tableDisableTd">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input readonly class="font_regular" placeholder="Auto Populated"
                              [disabled]="editedItemId !== item.id && !isFormDisabled" matInput>
                          </mat-form-field>
                          <label *ngIf="InvalidcompanyscoreWT && editedItemId === item.id"
                            class="red-cl font_regular fs-12">
                            score to final score converter plus company socre weightage is not equal to 100
                          </label>
                        </td> -->

                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input [(ngModel)]="item.individualKpiCompetencyWeightage" type="number"
                            (input)="GetScoreToFinalConverterTotalWeightage(item,'individualKpiCompetencyWeightage',rowId)"
                            [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled" matInput
                            placeholder="Type here" class="font_regular">
                        </mat-form-field>
                        <label *ngIf="InvalidIndividualCompetencyMaxTW && editedIndividualDeotCompanyScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Individual KPI and Competency weightage exceeds 100
                        </label>
                      </td>

                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input [(ngModel)]="item.deptKpiScore" type="number"
                            (input)="GetScoreToFinalConverterTotalWeightage(item,'deptKpiScore',rowId)"
                            [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled" matInput
                            placeholder="Type here" class="font_regular">
                        </mat-form-field>
                        <label *ngIf="InvalidDepthKpiMaxScore && editedIndividualDeotCompanyScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Dept KPI score exceeds 100
                        </label>
                      </td>

                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input [(ngModel)]="item.companyKPIScoreWeightage"
                            (input)="GetScoreToFinalConverterTotalWeightage(item,'companyKPIScoreWeightage',rowId)"
                            type="number" [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled"
                            matInput placeholder="Type here" class="font_regular">
                        </mat-form-field>
                        <label *ngIf="InvalidcompanyKpiScoreMaxScore && editedIndividualDeotCompanyScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Company KPI score exceeds 100
                        </label>
                      </td>

                      <td class="fs-14 font_regular">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input readonly [(ngModel)]="item.totalWeightage" type="number"
                            (input)="GetScoreToFinalConverterTotalWeightage(item,'totalWeightage',rowId)" matInput
                            placeholder="" class="font_regular">
                        </mat-form-field>
                        <label *ngIf="InvalidcompanyscoreWT && editedIndividualDeotCompanyScoreId === rowId"
                          class="red-cl font_regular fs-12">
                          Total weightage must be exactly 100
                        </label>
                      </td>
                      <td *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear">
                        <div class="d-flex">
                          <img (click)="onClickIndividualDeptcompetencyScoreEdit(rowId)"
                            *ngIf="editedIndividualDeotCompanyScoreId !== rowId" class="ml-5 p-10" title="Edit"
                            src="././assets/icon/edit.png" />
                          <span *ngIf="editedIndividualDeotCompanyScoreId === rowId && onCheckIconView"
                            (click)="removeRowData(rowId)" class="material-icons close p-10 cp fs-20">close</span>
                          <span
                            *ngIf="editedIndividualDeotCompanyScoreId === rowId && onCheckIconView && item.totalWeightage === 100"
                            (click)="onSaveincrementScoreToFinalScoreCompanyConverter(item)"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Score to rating -->

          <div class="cardBox mb-20">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Score to Rating Converter
                    <!-- <span [style.color]="buttonColorName">(Individual Score + Dept Score + Company Score)</span> -->
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <ion-row *ngFor="let item of ratingArrayForSetup">
                <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                  <div class="w-100 inputBox notAllowed"><span *ngIf="item.minRange!=0">></span>{{item.minRange}}</div>
                </ion-col>
                <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Max Range" class="font_regular"
                      [(ngModel)]="item.maxRange" (blur)="onMaxRangeChange(item)">
                  </mat-form-field>
                  <label *ngIf="item.maxRange== null && errorMsgForRating" class="red-cl font_regular fs-12">Max Range
                    is
                    required</label>
                  <label *ngIf="isInValidMaxRange"
                    class="red-cl font_regular fs-12">{{invalidErrMessageForRating}}</label>
                </ion-col>
                <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="text" placeholder="Rating" class="font_regular" [(ngModel)]="item.rating"
                      (blur)="onRatingEmpty(item)">
                  </mat-form-field>
                  <label *ngIf="item.rating== null && errorMsgForRating" class="red-cl font_regular fs-12">Rating is
                    required</label>
                  <label *ngIf="isInValidRating" class="red-cl font_regular fs-12">
                    Enter rating required
                  </label>
                </ion-col>
              </ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
                <ion-label *ngIf="ratingArrayForSetup.length==0 && !isVariablePayApproved && isSelectedYearIsSameYeartoCurrentYear" class="fs-16 font_regular blue mt-20 cp mr-15"
                  (click)="addMoreScoreRating()">+
                  Add</ion-label>
                <ion-label *ngIf="ratingArrayForSetup.length!=0" class="fs-16 font_regular blue mt-20 cp mr-15"
                  (click)="saveAddedScoreRating()">Save</ion-label>
                <ion-label *ngIf="ratingArrayForSetup.length!=0" class="fs-16 font_regular red mt-20 cp"
                  (click)="removecreatedScoresRating()">Remove</ion-label>
              </ion-col>

              <ion-row>
                <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7" class="p-0">
                  <ion-row class="p-0">
                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                      class="p-0 tableBorder brtopLeft8 tableBg text-center">
                      <div class="formLabelSemiBoldfs14 p-10">Score Range</div>
                    </ion-col>
                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                      class="p-0 tableBorder tableBg text-center">
                      <div class="formLabelSemiBoldfs14 p-10">Rating</div>
                    </ion-col>
                    <ion-col *ngIf="!isVariablePayApproved && isSelectedYearIsSameYeartoCurrentYear" size-sm="2" size-md="2" size-lg="2" size-xs="2"
                      class="p-0 tableBorder brtopRight8 tableBg text-center">
                      <span (click)="deleteScoreRating()" class="material-icons red p-10 cp fs-20">delete</span>
                    </ion-col>
                  </ion-row>
                  <ion-row class="p-0" *ngFor="let data of addedratingArray;let i=index">
                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="tableBorder text-center">
                      <div *ngIf="editIndexofRating!=i" class="formLabelRegularfs14 p-10">
                        <span *ngIf="data.minRange!=0">></span>{{data.minRange}} - {{data.maxRange}}
                      </div>
                      <label *ngIf="editIndexofRating==i" class="inputBox notAllowed"><span
                          *ngIf="data.minRange!=0">></span>{{data.minRange}}</label>
                      <span *ngIf="editIndexofRating==i">&nbsp;-&nbsp;</span>
                      <mat-form-field *ngIf="editIndexofRating==i" class="w-30 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Max Range" class="font_regular"
                          [(ngModel)]="data.maxRange">
                      </mat-form-field>
                    </ion-col>
                    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="tableBorder text-center">
                      <div *ngIf="editIndexofRating!=i" class="formLabelRegularfs14 p-10">
                        {{data.rating | titlecase}}</div>
                      <mat-form-field *ngIf="editIndexofRating==i" class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Normalize Score" class="font_regular"
                          [(ngModel)]="data.rating">
                      </mat-form-field>
                    </ion-col>
                    <ion-col *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" size-sm="2" size-md="2" size-lg="2" size-xs="2" class="tableBorder text-center">
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </div>
          </div>

          <!-- Overall Pay Budget Grid -->

          <div class="cardBox mb-20">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Overall Variable Pay Budget Grid
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <div class="setUptable-container">
                <div>
                  <!-- <ion-label class="fs-16 font_regular blue mt-20 cp mr-15" [style.color]="buttonColorName"
                    (click)="addOverallVariablePayBudgetGrid()" *ngIf="isVisibleOverallVariablePayBudgetGridAdd">+ Add
                    New</ion-label>
                  <ion-label class="fs-16 font_regular blue mt-20 cp mr-15" (click)="OnSaveFinalVariablePayPercentage()"
                    *ngIf="isVisibleOverallVariablePayBudgetGridSave">Save</ion-label> -->
                </div>
                <table class="hover mb-5 mt-10">
                  <thead class="bg-gray">
                    <tr>
                      <th class="fs-14 font_bold cl-black">Fiscal year</th>
                      <th class="fs-14 font_bold cl-black">No. of Eligible <br> Employees</th>
                      <th class="fs-14 font_bold cl-black">Fixed CTC of <br> Eligible Employee for VP</th>
                      <th class="fs-14 font_bold cl-black">Final VP %</th>
                      <th class="fs-14 font_bold cl-black">Final VP Amount</th>
                      <!-- <th class="fs-14 font_bold cl-black"></th> -->
                    </tr>
                  </thead>
                  <tbody class="bg-white">

                    <!-- <ng-container *ngIf="setupData">
                      <tr>
                        <td class="fs-14 font_regular">
                          <mat-form-field class="w-150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select Year" [(ngModel)]="setupData.fromYear">
                              <mat-option [value]="setupData.fromYear">{{setupData.fromYear}}</mat-option>
                              <mat-option [value]="setupData.toYear">{{setupData.toYear}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{setupData.noOfEligibleEmployees}}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{setupData.totalCtcOfEligibleEmployees}}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput type="number" placeholder="Text here" class="font_regular" [(ngModel)]="setupData.finalVPPercentage">
                          </mat-form-field>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{setupData.finalVPPercentage}}</span>
                        </td>
                      </tr>
                    </ng-container> -->

                    <ng-container>
                      <tr *ngFor="let item of GetOverallIncrementBudgetGridData; let id = index">
                        <td class="fs-14 font_regular">
                          <span>{{ sharedService.transformYearToFyFormat(item.year) }} - {{sharedService.transform(item.frequencyCycle)}}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.noOfEligibleEmployees != null ? item.noOfEligibleEmployees : 0 }}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.totalCtcOfEligibleEmployees != null ? item.totalCtcOfEligibleEmployees : 0 }}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [ngClass]="{'disableBtn':isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear}" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" 
                            type="number" placeholder="Text here" class="font_regular"
                              [(ngModel)]="item.finalVPPercentage" (blur)="calculateFinalIncrementAmount(item)"
                              (ngModelChange)="removeMinusValue(item)">
                          </mat-form-field>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ (item.finalVPAmount | number: '1.2-2') }}</span>
                        </td>
                        <!-- <td class="fs-14 font_regular">

                          <img (click)="editRow(id)"
                            *ngIf="isEditingRow !== id && item.year === overallIncrementBudgetGridCurrentYear"
                            class="ml-5 p-10" title="Edit" src="././assets/icon/edit.png" />
                          <span *ngIf="isEditingRow === id" (click)="cancelEdit(id)"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <span *ngIf="isEditingRow === id" (click)="OnSaveFinalVariablePercentage(item)" class="material-icons link p-10 cp fs-20">check</span>
                        </td> -->
                      </tr>
                      <tr *ngFor="let item of previousOverallVPBudgetGrid; let id = index">
                        <td class="fs-14 font_regular">
                          <span>{{ sharedService.transformYearToFyFormat(item.year) }} - {{sharedService.transform(item.frequencyCycle)}}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.noOfEligibleEmployees != null ? item.noOfEligibleEmployees : 0 }}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.totalCtcOfEligibleEmployees != null ? item.totalCtcOfEligibleEmployees : 0 }}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.finalVPPercentage != null ? item.finalVPPercentage : 0 }}</span>
                        </td>
                        <td class="fs-14 font_regular">
                          <span>{{ item.finalVPAmount != null ? (item.finalVPAmount | number: '1.2-2') : 0 }}</span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Variable Grid -->

          <div class="cardBox mb-20">
            <div class="headingOfShowBox font_medium fs-14">
              <ion-row class="p-0">
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <div class="formLabelBoldfs16">Variable Grid - Band & Rating Wise
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <div class="p-10">
              <div class="setUptable-container">
                <table class="hover mb-5">
                  <thead class="bg-gray">
                    <tr>
                      <th class="fs-14 font_bold cl-black">Band</th>
                      <th *ngFor="let data of addedratingArray" class="fs-14 font_bold cl-black">{{data.rating}}</th>
                      <th *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear"></th>
                    </tr>
                  </thead>
                  <tbody class="bg-white">
                    <tr *ngFor="let item of variableGridBandList; let rowId = index">
                      <td class="fs-14 font_bold">
                        <span>{{item.band.band ? item.band.band : item.band}}</span>
                      </td>
                      <td class="fs-14 font_regular" *ngFor="let data of addedratingArray; let colId = index">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput placeholder="Type number here" type="number" class="font_regular"
                            [(ngModel)]="item.variablepayPercentage[colId]"
                            (ngModelChange)="InvalidBandAndRatingWise(item, colId)"
                            [disabled]="editedBandAndRatingWiseId !== rowId && !isFormDisabled">
                        </mat-form-field>
                      </td>
                      <td *ngIf="!isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear">
                        <div class="d-flex">
                          <img (click)="onClickBandAndRatingWiseEdit(rowId)" *ngIf="editedBandAndRatingWiseId !== rowId"
                            class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                          <span (click)="GetIncrementGrid()"
                            *ngIf="editedBandAndRatingWiseId === rowId && onCheckIconView"
                            class="material-icons close p-10 cp fs-20">close</span>
                          <span (click)="saveGridBandRating()"
                            *ngIf="editedBandAndRatingWiseId === rowId && onCheckIconView"
                            class="material-icons link p-10 cp fs-20">check</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="mt-10">
            <button type="button" class="back_btn mr-10" (click)="onClickBreadcrumPMS()">Back</button>
            <button [ngClass]="{'disableBtn':isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear}" [disabled]="isVariablePayApproved || !isSelectedYearIsSameYeartoCurrentYear" (click)="getVariableInputData()" type="button" class="add_btn fs-14 mr-10"
              [style.background-color]="buttonColorName">Save</button>
          </div>
        </div>

      </div>
    </div>

    <!-- -------------------------------------- Dashboard Variable Pay ----------------------------------- -->
    <div class="container" *ngIf="selectedTypeTabName == 'Dashboard'">
      <div class="pt-10">
        <ion-row class="center-content">
          <ion-col size-sm="12" size-md="6" size-lg="10" size-xs="12">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="d-flex">

                  <mat-form-field class="w150 mat-height40 mat-input-style mr-15">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                      (selectionChange)="onYearChangeForInput($event);getVPCurrentYearFrequeny()">
                      <mat-option *ngFor="let item of companyYears" [value]="item.year">
                        {{ sharedService.transformYearToFyFormat(item.year) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="w150 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Period" [(ngModel)]="selectedDashboardMonthPeriod" (selectionChange)="updateDashboardPeriodOptions($event)">
                      <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                        {{ monthPeriod }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="variablepay-period ml-10">
                    <p>Variable Pay Frequency - <span>{{periodForDashboard ? periodForDashboard :
                        'NA'}}</span> | Cut of date <span>{{ counterDashboardData?.cutOffDate|date:'dd-MM-yyyy'}}</span></p>
                    <span *ngIf="isVPInputSetupNotDone" class="regular fs-12 ml-10" style="color: #E94848;">Setup not completed</span>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size-sm="12" size-md="6" size-lg="2" size-xs="12">
            <!-- <div class="variablepay-period">
              <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
            </div> -->
          </ion-col>
        </ion-row>
      </div>
      <div>
        <ion-row class="pt-10">
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold">Budget %</p>
                  <p class="mt-5 fs-14 font_bold blue">{{counterDashboardData?.budgetPercentage + '%' + '(' +
                    counterDashboardData?.budgetAmount + ')' ? counterDashboardData?.budgetPercentage + '(' +
                    counterDashboardData?.budgetAmount + ')' : 'NA'}}</p>
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold">No. of employees</p>
                  <p class="mt-5 fs-14 font_bold yellow">{{counterDashboardData?.noOfEmployees}}</p>
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="openDashboardPopups('empCTC')">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold cp">Emp. given % of CTC</p>
                  <p class="mt-5 fs-14 font_bold text_green cp">{{counterDashboardData?.empGivenVPPercentOfCtc}}</p>
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="openDashboardPopups('fixedBudget')">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold cp">Emp. given Fixed Budget VP</p>
                  <p class="mt-5 fs-14 font_bold Cerulean-Blue cp">{{counterDashboardData?.empGivenVPFixedBudget}}</p>           
                </div>
              </div>     
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="pt-10">
          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold">Actual Variable Payout</p>
                  <p class="mt-5 fs-14 font_bold red">{{counterDashboardData?.actualVariablePayout}}</p>         
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card" (click)="openDashboardPopups('eligibleEmployees')">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold cp">Eligible employees</p>
                  <p class="mt-5 fs-14 font_bold text-rich-blue cp">{{counterDashboardData?.eligibleEmployeesMale}} |
                    {{counterDashboardData?.eligibleEmployeesFemale}} | {{counterDashboardData?.eligibleEmployeesDoNotDisclose}}</p>       
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold">Avg.of VP % Given on CTC</p>
                  <p class="mt-5 fs-14 font_bold Medium-Turquoise-blue">
                    {{counterDashboardData?.avgOfVPPercentGivenOnCtc}}</p>    
                </div>
              </div>     
            </div>
          </ion-col>

          <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
            <div class="card">
              <div class="verticle-center">
                <div class="icon-wrapper">
                  <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
                </div>
                <div class="text-wrapper">
                  <p class="fs-14 font_semibold">Avg. of Fixed Budget VP given</p>
                  <p class="mt-5 fs-14 font_bold red">{{counterDashboardData?.avgOfFixedBudgetVpGiven}}</p>  
                </div>
              </div>     
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div>
        <ion-row class="pt-10">
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="6" size-xs="12">
                  <div class="fs-16 font_bold">Budget vs Actual</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <span (click)="switchBudgetVsActualGraphType('bar')">
                      <img *ngIf="BudgetVsActualIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="BudgetVsActualIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchBudgetVsActualGraphType('pie')">
                      <img *ngIf="BudgetVsActualIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="BudgetVsActualIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                    </span> -->
                    <span (click)="BudgetVsActualTableData()">
                      <img *ngIf="!BudgetVsActualTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                      <img *ngIf="BudgetVsActualTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchBudgetVsActualGraphType('line')">
                      <img *ngIf="BudgetVsActualIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="BudgetVsActualIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="OnClickDownloadBudgetvsActualGraph()">
                      <img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="5" size-xs="3">
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" (selectionChange)="updateActualVsBudgetOption($event)"
                        [(ngModel)]="monthPeriodForBudget">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ion-col>
              </ion-row>
              <div [ngClass]="{'dispNone' : !BudgetVsActualTable}" id="budgetWiseTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of getBudgetVsActualData">
                      <td>{{data.budgetAmount}}</td>
                      <td>{{data.actualAmount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div [ngClass]="{'dispNone' : BudgetVsActualTable}">
                <div id="budgetWiseGraph" style="width: 500px; height: 400px;"></div>
              </div>
            </div>
          </ion-col>
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Gender Wise - Budget vs Actual</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <span (click)="switchGenderWiseBudgetVsActualGraphType('bar')">
                      <img *ngIf="generWiseBudgetVsActualIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="generWiseBudgetVsActualIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchGenderWiseBudgetVsActualGraphType('pie')">
                      <img *ngIf="generWiseBudgetVsActualIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="generWiseBudgetVsActualIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                    </span> -->
                    <span (click)="GenderWiseBudgetVsActualTableData()">
                      <img *ngIf="!GenerWiseBudgetVsActualTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                      <img *ngIf="GenerWiseBudgetVsActualTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchGenderWiseBudgetVsActualGraphType('line')">
                      <img *ngIf="generWiseBudgetVsActualIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="generWiseBudgetVsActualIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadGenderWiseBudgetVsActualGraph()">
                      <img src="././assets/icon/downloadIcon.svg" alt="">
                    </span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" (selectionChange)="updateGenderWiseOption($event)"
                        [(ngModel)]="monthPeriodForGender">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-select [clearable]="false" class="w250 ml-10" placeholder="Select Department" [(ngModel)]="deptForGender"
                    (change)="updateGenderWiseOptionForDept($event)" [clearable]="false">
                    <ng-option [value]="'All'">My Departments</ng-option>
                    <ng-option [value]="item.id"
                        *ngFor="let item of frequencyDeptName">{{item.id}}</ng-option>
                    </ng-select>
                  </div>
                </ion-row>
              </div>

              <div [ngClass]="{'dispNone' : !GenerWiseBudgetVsActualTable}" id="genderWiseVariablePayTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Gender</th>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of genderWiseData">
                      <td>{{data.gender}}</td>
                      <td>{{data.budgetAmount}}</td>
                      <td>{{data.actualAmount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : GenerWiseBudgetVsActualTable}">
                <div id="genderWiseVariablePayGraph" style="width: 100%; height: 400px;"></div>
              </div>
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="pt-10">
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Dept wise Budget vs Actual</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span> -->

                    <span (click)="switchDeptWiseBudgetVsActualGraphType('bar')">
                      <img *ngIf="deptWiseBudgetVsActualIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="deptWiseBudgetVsActualIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchDeptWiseBudgetVsActualGraphType('pie')">
                      <img *ngIf="deptWiseBudgetVsActualIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="deptWiseBudgetVsActualIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                    </span> -->
                    <span (click)="deptWiseBudgetVsActualTableData()">
                      <img *ngIf="!deptWiseBudgetVsActualTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                      <img *ngIf="deptWiseBudgetVsActualTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchDeptWiseBudgetVsActualGraphType('line')">
                      <img *ngIf="deptWiseBudgetVsActualIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="deptWiseBudgetVsActualIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadDeptWiseBudgetVsActualGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" (selectionChange)="updateDeptWiseOption($event)"
                        [(ngModel)]="monthPeriodForDept">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-multiselect-dropdown class="w250 ml-10 mat mat-height40 mat-input-style"
                    [placeholder]="'Select Department'" [(ngModel)]="deptWiseBudgetVsActualDept" [settings]="dropdownSettings" [data]="getDepartmentsList"
                    (onSelect)="getDashBoardDeptWise()" (onDeSelect)="getDashBoardDeptWise()"
                    (onSelectAll)="selectAllDeptWiseDashboard($event)"
                    (onDeSelectAll)="onDeSelectAllDeptWiseDashboard()">
                  </ng-multiselect-dropdown>
                  </div>
                </ion-row>
              </div>


              <div [ngClass]="{'dispNone' : !deptWiseBudgetVsActualTable}" id="deptWiseVariablePayTable">
                <div class="dashboardGraphTable">
                  <table>
                    <thead>
                      <tr>
                        <th>Department </th>
                        <th>Budget Amount</th>
                        <th>Actual Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of deptWiseData">
                        <td>{{data.department}}</td>
                        <td>{{data.budgetAmount | number:'1.4-4'}}</td>
                        <td>{{data.actualAmount | number:'1.4-4'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div [ngClass]="{'dispNone' : deptWiseBudgetVsActualTable}">
                <div id="deptWiseVariablePayGraph" style="width: 100%; height: 400px;"></div>
              </div>
            </div>
          </ion-col>

          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Rating wise Budget vs Actual</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/downloadIcon.svg" alt=""></span> -->

                    <span (click)="switchRatingWiseBudgetVsActualGraphType('bar')">
                      <img *ngIf="ratingWiseIncrementAmountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="ratingWiseIncrementAmountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <!-- <span (click)="switchRatingWiseBudgetVsActualGraphType('pie')">
                      <img *ngIf="ratingWiseIncrementAmountIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="ratingWiseIncrementAmountIcon == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span> -->
                    <span (click)="ratingWiseBudgetVsActualTableData()">
                      <img *ngIf="!ratingWiseIncrementAmountTable" src="././assets/icon/tableIcon.svg" alt=""
                        class="cp">
                      <img *ngIf="ratingWiseIncrementAmountTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchRatingWiseBudgetVsActualGraphType('line')">
                      <img *ngIf="ratingWiseIncrementAmountIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="ratingWiseIncrementAmountIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadRatingWiseBudgetVsActualGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" (selectionChange)="updateRateWiseOption($event)"
                        [(ngModel)]="monthPeriodForRating">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-select [clearable]="false" class="w250 ml-10" placeholder="Select Department" [(ngModel)]="deptForRating"
                    (change)="updateRateWiseOptionForDept($event)">
                    <ng-option [value]="'All'">My Departments</ng-option>
                    <ng-option [value]="item.id"
                        *ngFor="let item of frequencyRating">{{item.id}}</ng-option>
                    </ng-select>
                  </div>
                </ion-row>
              </div>

              <div [ngClass]="{'dispNone' : !ratingWiseIncrementAmountTable}" id="rateWiseVariablePayTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Ratings </th>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of rateWiseData">
                      <td>{{data.rating}}</td>
                      <td>{{data.budgetAmount | number:'1.4-4'}}</td>
                      <td>{{data.actualAmount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : ratingWiseIncrementAmountTable}">
                <!-- <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"> -->
                <div id="rateWiseVariablePayGraph" style="width: 100%; height: 400px;"></div>
                <!-- </ion-col> -->
              </div>
              <!-- <div id="rateWiseVariablePayGraph" style="width: 100%; height: 400px;"></div> -->
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="pt-10">
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Band wise Budget vs Actual</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/downloadIcon.svg" alt=""></span> -->

                    <span (click)="switchBandWiseBudgetVsActualGraphType('bar')">
                      <img *ngIf="bandWiseIncrementAmountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="bandWiseIncrementAmountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchBandWiseBudgetVsActualGraphType('pie')">
                      <img *ngIf="bandWiseIncrementAmountIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="bandWiseIncrementAmountIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                    </span> -->
                    <span (click)="bandWiseBudgetVsActualTableData()">
                      <img *ngIf="!bandWiseBudgetVsActualsTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                      <img *ngIf="bandWiseBudgetVsActualsTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchBandWiseBudgetVsActualGraphType('line')">
                      <img *ngIf="bandWiseIncrementAmountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="bandWiseIncrementAmountIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadBandWiseBudgetVsActualGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Period" (selectionChange)="updateBandWiseOption($event)"
                        [(ngModel)]="monthPeriodForBand">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-select [clearable]="false" class="w250 ml-10" placeholder="Select Department" [(ngModel)]="deptForBand"
                    (change)="updateBandWiseOptionForDept($event)">
                    <ng-option [value]="'All'">My Departments</ng-option>
                    <ng-option [value]="item.id"
                        *ngFor="let item of frequencyBand">{{item.id}}</ng-option>
                    </ng-select>
                  </div>
                </ion-row>
              </div>

              <div [ngClass]="{'dispNone' : !bandWiseBudgetVsActualsTable}" id="bandWiseVariablePayTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Bands </th>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of bandWiseData">
                      <td>{{data.band}}</td>
                      <td>{{data.budgetAmount | number:'1.4-4'}}</td>
                      <td>{{data.actualAmount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : bandWiseBudgetVsActualsTable}">
                <div id="bandWiseVariablePayGraph" style="width: 100%; height: 400px;"></div>
              </div>
              <!-- <div id="bandWiseVariablePayGraph" style="width: 100%; height: 400px;"></div> -->
            </div>
          </ion-col>

          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Rating vs Employee count</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/downloadIcon.svg" alt=""></span> -->

                    <span (click)="switchRateEmployeeWiseBudgetVsActualGraphType('bar')">
                      <img *ngIf="ratingVsEmpCountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="ratingVsEmpCountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <span (click)="switchRateEmployeeWiseBudgetVsActualGraphType('pie')">
                      <img *ngIf="ratingVsEmpCountIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="ratingVsEmpCountIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                    </span>
                    <span (click)="ratingVsEmpCountTableData()">
                      <img *ngIf="!ratingVsEmpCountTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                      <img *ngIf="ratingVsEmpCountTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchRateEmployeeWiseBudgetVsActualGraphType('line')">
                      <img *ngIf="ratingVsEmpCountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="ratingVsEmpCountIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                    </span>
                    <span (click)="downloadRatingVsEmployeeCountGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mb-10 mat-input-style">
                      <mat-select placeholder="Select Period"
                        (selectionChange)="updateRateEmployeeWiseOption($event)"
                        [(ngModel)]="monthPeriodForRatingCount">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-select [clearable]="false" class="w250 ml-10" placeholder="Select Department" [(ngModel)]="deptForRateVsEmloyee"
                    (change)="updateYearVsEmolyeeOptionForDept($event)">
                    <ng-option [value]="'All'">My Departments</ng-option>
                    <ng-option [value]="item.id"
                        *ngFor="let item of frequencyEmployeeVSBand">{{item.id}}</ng-option>
                    </ng-select>
                  </div>
                </ion-row>
              </div>


              <div [ngClass]="{'dispNone' : !ratingVsEmpCountTable}" id="ratingWiseVariablePayTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Rating</th>
                      <th>Employee Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of rateEmployeeWiseData">
                      <td>{{data.rating}}</td>
                      <td>{{data.employeeCount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : ratingVsEmpCountTable}">
                <div id="ratingWiseVariablePayGraph" style="width: 100%; height: 400px;"></div>
              </div>
              <!-- <div id="ratingWiseVariablePayGraph" style="width: 100%; height: 400px;"></div> -->
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="pt-10">
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Year vs Budget & Actual Amount</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/downloadIcon.svg" alt=""></span> -->

                    <span (click)="switchYearVsBudgetActualAmountGraphType('bar')">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg"
                        alt="">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                        alt="">
                    </span>
                    <!-- <span (click)="switchYearVsBudgetActualAmountGraphType('pie')">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon != 'pie'" src="././assets/icon/pieChartIcon.svg"
                        alt="">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon == 'pie'" src="././assets/icon/PieIconActive.svg"
                        alt="">
                    </span> -->
                    <span (click)="yearVsBudgetEmpCountTableData()">
                      <img *ngIf="!yearVsBudgetAndActualAmountTable" src="././assets/icon/tableIcon.svg" alt=""
                        class="cp">
                      <img *ngIf="yearVsBudgetAndActualAmountTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchYearVsBudgetActualAmountGraphType('line')">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                        alt="">
                      <img *ngIf="yearVsBudgetAndActualAmountIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                        alt="">
                    </span>
                    <span (click)="downloadYearVsBudgetActualAmountGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <ion-col size-sm="8" size-md="8" size-lg="12" size-xs="8">
                      <ng-select [clearable]="false" class="w250 ml-10" placeholder="Select Department" [(ngModel)]="selectGenderWiseBudgetVsActualDept"
                      (change)="getDashBoardActualAmountWise()">
                      <ng-option [value]="'All'">My Departments</ng-option>
                      <ng-option [value]="item.id"
                          *ngFor="let item of getDepartmentsList">{{item.id}}</ng-option>
                      </ng-select>
                  </ion-col>
                </ion-row>
              </div>


              <div [ngClass]="{'dispNone' : !yearVsBudgetAndActualAmountTable}" id="actualAmountVariablePayTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Year</th>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of ActualAmountWiseData">
                      <td>{{data.year}}</td>
                      <td>{{data.budgetAmount | number:'1.4-4'}}</td>
                      <td>{{data.actualAmount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : yearVsBudgetAndActualAmountTable}">
                <div id="actualAmountVariablePayGraph" style="width: 100%; height: 400px;"></div>
              </div>
              <!-- <div id="actualAmountVariablePayGraph" style="width: 100%; height: 400px;"></div> -->
            </div>
          </ion-col>

          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="graphs m-50">
              <ion-row class="justify-content-center">
                <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                  <div class="fs-16 font_bold">Dept Wise Eligible and Not Eligible <br> Employee Count</div>
                </ion-col>
                <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                  <div class="d-flex graph-icon">
                    <!-- <span><img src="././assets/icon/activeTable.svg" alt=""></span>
                      <span><img src="././assets/icon/pieChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/tableIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/lineChartIcon.svg" alt=""></span>
                      <span><img src="././assets/icon/downloadIcon.svg" alt=""></span> -->

                    <span (click)="switchEligibleEmployeeWiseDataGraphType('bar')">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon != 'bar'"
                        src="././assets/icon/BarGraphIcon.svg" alt="">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon == 'bar'"
                        src="././assets/icon/BarGraphActive.svg" alt="">
                    </span>
                    <!-- <span (click)="switchEligibleEmployeeWiseDataGraphType('pie')">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon != 'pie'"
                        src="././assets/icon/pieChartIcon.svg" alt="">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon == 'pie'"
                        src="././assets/icon/PieIconActive.svg" alt="">
                    </span> -->
                    <span (click)="deptWiseEligibleAndNonEligibleCountLineGraphTable()">
                      <img *ngIf="!deptWiseEligibleAndNonEligibleEmpCountTable" src="././assets/icon/tableIcon.svg" alt=""
                        class="cp">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountTable" src="././assets/icon/TableIconActive.svg" alt="">
                    </span>
                    <span (click)="switchEligibleEmployeeWiseDataGraphType('line')">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon != 'line'"
                        src="././assets/icon/lineChartIcon.svg" alt="">
                      <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon == 'line'"
                        src="././assets/icon/activeLineChart.svg" alt="">
                    </span>
                    <span (click)="downloadDeptWiseEligibleNonEligibleGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>
                  </div>
                </ion-col>
              </ion-row>
              <div class="mt-10 mb-10">
                <ion-row>
                  <div class="d-flex">
                    <mat-form-field class="w200 mat-height40 mat-input-style">
                      <!-- <mat-select placeholder="Select Period"
                        (selectionChange)="updateDashboardPeriodOptions($event)"
                        [(ngModel)]="monthPeriodForDeptWiseEligbleNonEligible">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select> -->
                      <mat-select placeholder="Select Period" [(ngModel)]="monthPeriodForDeptWiseEligbleNonEligible" (selectionChange)="updateDashboardPeriodOptions($event)">
                        <mat-option *ngFor="let monthPeriod of vpFrequency" [value]="monthPeriod">
                          {{ monthPeriod }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-multiselect-dropdown class="w250 mat mat-height40 ml-10  mat-input-style"
                    [(ngModel)]="selectedDeptNameForEligbleNonEligible" [placeholder]="'Select Department'" [settings]="dropdownSettings" [data]="getDepartmentsList"
                    (onSelect)="getDashBoardEligibleEmployeeWise()"
                    (onDeSelect)="getDashBoardEligibleEmployeeWise()"
                    (onSelectAll)="selectAllEligibleEmployeesWiseDashboard($event)"
                    (onDeSelectAll)="onDeSelectAllEligibleEmployeesWiseDashboard()">
                  </ng-multiselect-dropdown>
                  </div>
                </ion-row>
              </div>

              <div [ngClass]="{'dispNone' : !deptWiseEligibleAndNonEligibleEmpCountTable}" id="eligibleEmployeeCountTable">
                <table class="dashboardGraphTable">
                  <thead>
                    <tr>
                      <th>Department</th>
                      <th>Eligible</th>
                      <th>Not Eligible</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of eligibleEmployeeWiseData">
                      <td>{{data.department}}</td>
                      <td>{{data.eligibleCount | number:'1.4-4'}}</td>
                      <td>{{data.notEligibleCount | number:'1.4-4'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div [ngClass]="{'dispNone' : deptWiseEligibleAndNonEligibleEmpCountTable}">
                <div id="eligibleEmployeeCountGraph" style="width: 100%; height: 400px;"></div>
              </div>
              <!-- <div id="eligibleEmployeeCountGraph" style="width: 100%; height: 400px;"></div> -->
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <!-- -------------------------------------- Variable Pay Input --------------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Variable Pay Input'">
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex">
            <div class="d-flex">
              <button type="button" (click)="onClickVariablePayIntputActiveTab(true)"
                [ngClass]="{'activeVariablePayInputTab' : activeVariablePayInputTab}"
                class="borderRadiusRight tabsBtn center-content fs-14"><span class="displayContent">
                  Eligible ({{totalEligibleCount||0}})</span></button>
              <button type="button" (click)="onClickVariablePayIntputActiveTab(false)"
                [ngClass]="{'activeVariablePayInputTab' : !activeVariablePayInputTab}"
                class="borderRadiusLeft tabsBtn center-content fs-14"><span class="displayContent">
                  Non Eligible ({{totalNonEligibleCount||0}})</span></button>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"
                (selectionChange)="onYearChangeForVPInput($event);getVPCurrentYearFrequeny()">
                <mat-option *ngFor="let item of companyYears" [value]="item.year">
                  {{ sharedService.transformYearToFyFormat(item.year) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select placeholder="Select Period" [(ngModel)]="frequencyPeriod"
                (selectionChange)="updateInputOptions($event);getVPIDByFrequency()">
                <mat-option *ngFor="let month of variablePeriodFrquency" [value]="month">
                  {{ month }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Department'" [settings]="dropdownSettings"
              [data]="getDepartmentsList" [(ngModel)]="selectedDepartment" (onSelect)="onSelectDepartment()"
              (onDeSelect)="onDeSelectDepartment()" (onSelectAll)="selectAllDepartment($event)"
              (onDeSelectAll)="onDeSelectAllDepartment()">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Band'" [settings]="dropdownSettings"
              [data]="getBandList" [(ngModel)]="selectedBand" (onSelect)="onSelectdBand()"
              (onDeSelect)="onDeSelectdBand()" (onSelectAll)="selectAllBand($event)"
              (onDeSelectAll)="onDeSelectAllBand()">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Manager'" [settings]="dropdownSettings"
              [data]="getManagerList" [(ngModel)]="selectedManager" (onSelect)="onSelectdManager()"
              (onDeSelect)="onDeSelectdManager()" (onSelectAll)="selectAllManager($event)"
              (onDeSelectAll)="onDeSelectAllManager()">
            </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <!-- <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select multiple placeholder="Select Employees" (selectionChange)="updateEmployees($event)">
                <mat-option>All</mat-option>
              </mat-select>
            </mat-form-field> -->

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Employee'" [settings]="dropdownSettings"
              [data]="getEmployeeList" [(ngModel)]="selectedEmployee" (onSelect)="onSelectdEmployee()"
              (onDeSelect)="onDeSelectdEmployee()" (onSelectAll)="selectAllEmployee($event)"
              (onDeSelectAll)="onDeSelectAllEmployee()">
            </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>

      <div class="tableCardBox mt-15 mb-100">
        <ion-row>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex">
              <mat-form-field class="mat-height40 mat-input-style">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onSearchInput($event)">
              </mat-form-field>
              <div *ngIf="isVPInputSetupNotDone" class="regular fs-14 mt-10 ml-10" style="color: #E94848;">Setup not completed</div>
              <!-- <ion-label class="center-content ml-10 fs-14 font_medium pr-10 black_color">Show</ion-label> -->

              <!-- <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select [(value)]="selected" placeholder="Select">
                  <mat-option value="25">25</mat-option>
                  <mat-option value="50">50</mat-option>
                  <mat-option value="75">75</mat-option>
                  <mat-option value="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="center-content fs-14 font_medium pl-10 black_color">entries</ion-label> -->
            </div>
          </ion-col>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex float-right">
              <div class="mr-15" *ngIf="isAnyColumnInvisible">
                <div class="font_regular fs-12">Some Columns are hidden-</div>
                <div class="font_regular fs-12 text-right" [style.color]="buttonColorName"><u class="cp"
                (click)="onClickShowAllHeader()">click here to show all</u></div>
            </div>
              <div class="mr-15 center-content">
                <div class="font_regular fs-12">Status : 
                  <span style="color: #E94848;" *ngIf="!isVariablePayApproved">Pending</span> 
                  <span style="color: #34951e;" *ngIf="isVariablePayApproved">Approved</span>
                </div>
              </div>
              <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadvpInputExcelFile()">
                <span class="material-icons">download</span></button>
              <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                class="customMaterialIcon fs-14">
                <span class="material-icons">tune</span></button>

              <mat-menu #menu="matMenu">
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                    *ngFor="let item of variablePayInputTableHideShowAllData" class="mat-checkbox-style">
                    <mat-checkbox [(ngModel)]="item.isVisible" class="fs-12 font_semibold "
                      (change)="onSelectVariableInputHideShowCheckBox($event)" [checked]="item.isVisible" value="true"
                      (click)="$event.stopPropagation()" value=true>{{item.fieldName}}</mat-checkbox>
                  </ion-col>
                </ion-row>
              </mat-menu>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="p-5 mt-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">

              <!-- Eligible Input Table -->
              <table class="increment-tabs-table" *ngIf="activeVariablePayInputTab" id="vpInputEligibleTable">
                <thead>
                  <tr>
                    <ng-container *ngFor="let item of variablePayInputTableHideShowAllData; let i = index">
                      <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                          {{item.fieldName}}
                          <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                            (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementInputEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                            <mat-form-field class="w150 mat-height40 mat-input-style" *ngIf="(!isShowExcelData && loggedInUserRole == 'HOD' 
                            && !isSenForHRForApproval) || (!isShowExcelData && loggedInUserRole != 'HOD')">
                              <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                                (selectionChange)="onEditIncrementInputTableData(employee, employee.id)"
                                [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <span *ngIf="isShowExcelData || (loggedInUserRole == 'HOD' && isSenForHRForApproval)">{{employee.isEligible}}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>

                          <!-- Additional Information -->
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')">
                            <mat-form-field *ngIf="loggedInUserRole == 'HOD' && !isSenForHRForApproval && !isShowExcelData"
                              class="mat-height40 w150 mat-input-style">
                              <input matInput type="text" 
                              placeholder="Type here"
                              (keypress)="validateInputForNormalization($event)"
                              (blur)="onEditIncrementInputTableData(employee,employee.id)"
                              [(ngModel)]="employee.normalisationHhod"
                              [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved">
                            </mat-form-field>
                            <span *ngIf="isShowExcelData || loggedInUserRole != 'HOD' || (loggedInUserRole == 'HOD' && isSenForHRForApproval)">{{ employee.normalisationHhod}}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HR normalization')">
                            <mat-form-field *ngIf="(loggedInUserRole == 'HR Admin' ||
                            loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' ||
                            isShowMD)  && !isShowExcelData" class="mat-height40 w150 mat-input-style">
                              <input matInput type="text" 
                              placeholder="Type here"
                              (keypress)="validateInputForNormalization($event)"
                              (blur)="onEditIncrementInputTableData(employee,employee.id)"
                              [(ngModel)]="employee.normalisationHRMDCEO"
                              [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved"
                              >
                            </mat-form-field>
                            <span *ngIf="isShowExcelData || (loggedInUserRole == 'HOD' && !isShowMD)">{{ employee.normalisationHRMDCEO }}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">{{totalEligibleTotalFixedCtcPM | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA | number:'1.2-2'}}</td>
                      <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Rating')"> </td>
                      <td *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                    </td>
                    <td *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">{{totalEligibleDaysPeriod | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HR normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">{{totalEligibleVBAmount | number:'1.2-2'}}</td>
                  </tr>
                </tfoot>
              </table>

              <!-- Non Eligible Input Table -->

              <table class="increment-tabs-table" *ngIf="!activeVariablePayInputTab" id="vpInputNonEligibleTable">
                <thead>
                 <tr>
                  <ng-container *ngFor="let item of variablePayInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{item.fieldName}}
                        <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                          (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                      </div>
                    </th>
                  </ng-container>
                 </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementInputNonEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                            <mat-form-field class="w150 mat-height40 mat-input-style" *ngIf="(!isShowExcelData && loggedInUserRole == 'HOD' 
                            && !isSenForHRForApproval) || (!isShowExcelData && loggedInUserRole != 'HOD')">
                              <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                                (selectionChange)="onEditIncrementInputTableData(employee, employee.id)"
                                [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <span *ngIf="isShowExcelData  || (loggedInUserRole == 'HOD' && isSenForHRForApproval)">{{employee.isEligible}}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>

                          <!-- Additional Information -->
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')">
                            <mat-form-field *ngIf="loggedInUserRole == 'HOD' && !isShowExcelData && !isSenForHRForApproval " class="mat-height40 w150 mat-input-style">
                              <input matInput type="text" placeholder="Type here"
                              (keypress)="validateInputForNormalization($event)"
                                (blur)="onEditIncrementInputTableData(employee,employee.id)"
                                [(ngModel)]="employee.normalisationHhod"
                                [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved || isHODDisabledHRnormalization">
                            </mat-form-field>
                            <span *ngIf="isShowExcelData || loggedInUserRole != 'HOD'|| (loggedInUserRole == 'HOD' && isSenForHRForApproval)">{{ employee.normalisationHhod}}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HR normalization')">
                            <mat-form-field *ngIf="loggedInUserRole == 'HR Admin' ||
                            loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' ||
                            isShowMD && !isShowExcelData" class="mat-height40 w150 mat-input-style">
                              <input matInput type="text" placeholder="Type here"
                              (keypress)="validateInputForNormalization($event)"
                                (blur)="onEditIncrementInputTableData(employee,employee.id)"
                                [(ngModel)]="employee.normalisationHRMDCEO"
                                [disabled]="(loggedInUserRole == 'HOD' && isFreezForHOD) || (loggedInUserRole == 'HOD' && isSenForHRForApproval) || isSenForMDCeoForApproval || isVariablePayApproved || isHRAdminDisabledHODnormalization">
                            </mat-form-field>
                            <span *ngIf="isShowExcelData || (loggedInUserRole == 'HOD' && !isShowMD)">{{ employee.normalisationHRMDCEO }}</span>
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount}}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">{{totalEligibleTotalFixedCtcPM | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA | number:'1.2-2'}}</td>
                      <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Rating')"> </td>
                      <td *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                    </td>
                    <td *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">{{totalEligibleDaysPeriod | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HR normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">{{totalEligibleVBAmount | number:'1.2-2'}}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </ion-col>
        </ion-row>

        <!-- <ion-row class="mb-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
            <ion-label *ngIf="activeVariablePayInputTab"
              class="fs-14 font_bold black_color">{{getIncrementInputEligibleTableData.length}} entries</ion-label>
            <ion-label *ngIf="!activeVariablePayInputTab"
              class="fs-14 font_bold black_color">{{getIncrementInputNonEligibleTableData.length}} entries</ion-label>
          </ion-col>
        </ion-row> -->
      </div>

      <!-- <ion-row>
        <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="center-content">
        </ion-col>
        <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="p-0 text-right display-end">
          <ul class="dt_pagination">
            <ion-row class="float-right pgintn">
              <li class="active fs-16 font_regular">1</li>
              <span class="fs-14 font_regular p-10">of 2</span>
              <li class="fs-24 cp" [ngClass]="{'disableBtn': currentPageNumberOfVariablePay==1}">&lt;</li>
              <li class="fs-24 cp mr-0"
                [ngClass]="{'disableBtn': currentPageNumberOfVariablePay >= totalPagesOfVariablePay}">&gt;</li>
            </ion-row>
          </ul>
        </ion-col>
      </ion-row> -->
    </div>

    <ion-row class="footerBox" *ngIf="selectedTypeTabName == 'Variable Pay Input' && activeVariablePayInputTab">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0 text-right">
        <!-- [disabled]="!isVariablePayApproved" -->
        <button *ngIf="loggedInUserRole != 'HOD' || isShowMD" [disabled]="!isVariablePayApproved" 
        [ngClass]="{'disableBtn':!isVariablePayApproved}"
           type="button" class="back_btn fs-14 mr-15 Generate-increment-letters"
          (click)="onClickGenerateVariablePayLetters()">
          Generate Variable Pay letters</button>
        <button *ngIf="loggedInUserRole != 'HOD'" type="button" class="back_btn fs-14 mr-15"
          [style.color]="buttonColorName" [ngClass]="{'disableBtn':isFreezForHOD || isSenForMDCeoForApproval}" 
          [disabled]="isFreezForHOD || isSenForMDCeoForApproval"
          [style.border-color]="buttonColorName" (click)="vpApproval('Freeze for the HOD')">
          Freeze for the HOD</button>
        <!-- <button type="button" class="add_btn fs-14 mr-5"  *ngIf="loggedInUserRole == HOD ? "[style.background-color]="buttonColorName">
            Send to MD/CEO for Approval</button> -->
        <button type="button" class="add_btn fs-14 mr-5" [ngClass]="{'disableBtn':isVariablePayApproved || isSenForMDCeoForApproval}"
          [disabled]="isVariablePayApproved || isSenForMDCeoForApproval" *ngIf="isShowMD"
          [ngStyle]="{'background-color': '#f18509'}" (click)="vpApproval('Approve Variable Pay')">
          Approve Variable Pay
        </button>

        <button type="button" class="add_btn fs-14 mr-5" [ngClass]="{'disableBtn':isSenForHRForApproval || isSenForMDCeoForApproval}"
          [disabled]="isSenForHRForApproval || isSenForMDCeoForApproval" *ngIf="loggedInUserRole == 'HOD' && !isShowMD"
          [ngStyle]="{'background-color': '#f18509'}" (click)="vpApproval('Send to HR for Approval')">
          Send to HR for Approval
        </button>

        <button type="button" class="add_btn fs-14 mr-5" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'" [ngClass]="{'disableBtn':isSenForMDCeoForApproval}"
          [disabled]="isSenForMDCeoForApproval" [ngStyle]="{'background-color': buttonColorName}"
          (click)="vpApproval('Send to MDCEO for Approval')">
          Send to MD/CEO for Approval
        </button>

      </ion-col>
    </ion-row>

    <!-- -------------------------------------- Variable Pay Summary ------------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Variable Pay Summary'">
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChangeVPSummary($event);getVPCurrentYearFrequeny()">
                <mat-option *ngFor="let item of companyYears" [value]="item.year">
                  {{ sharedService.transformYearToFyFormat(item.year) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w200 mat-height40 mat-input-style ml-15">
              <!-- <mat-select placeholder="Select Period"> -->
              <!-- <mat-option>Jan - March</mat-option>
                <mat-option>April - June</mat-option>
                <mat-option>May - Sept</mat-option>
                <mat-option>Oct - Dec</mat-option> -->

              <mat-select placeholder="Select Period" [(ngModel)]="frequencyPeriod"
                (selectionChange)="updateSummaryOptions($event)">
                <mat-option *ngFor="let month of variablePeriodFrquencySummary" [value]="month">
                  {{ month }}
                </mat-option>
              </mat-select>
              <!-- </mat-select> -->
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <div class="tableCardBox mt-15 mb-15">
        <ion-row>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex">
              <mat-form-field class="mat-height40 mat-input-style">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onSearch($event)">
              </mat-form-field>
              <span *ngIf="isVPInputSetupNotDone" class="regular fs-12 mt-10 ml-10" style="color: #E94848;">Setup not completed</span>
            </div>
          </ion-col>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex float-right">
              <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadvpSummaryExcelFile('vpSummaryTable')">
                <span class="material-icons">download</span></button>
              <!-- <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                class="customMaterialIcon fs-14">
                <span class="material-icons">tune</span></button> -->
              <mat-menu #menu="matMenu">
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="mat-checkbox-style">
                    <mat-checkbox value="true">Dept</mat-checkbox>
                  </ion-col>
                </ion-row>
              </mat-menu>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="p-5 mt-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container Summary-Table-container">
              <table class="increment-tabs-table Increment-Summary-table" id="vpSummaryTable">
                <thead>
                 <tr>
                  <ng-container *ngFor="let item of variablePaySummaryTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{item.fieldName}}
                        <!-- <span class="material-icons cp ml-5 mt-3 fs-14"
                          (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span> -->
                      </div>
                    </th>
                  </ng-container>
                 </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of variableSummaryData">
                    <tr>
                      <td [attr.rowspan]="department.bands.length + 1">{{ department.departmentName }}</td>
                      <td>{{ department.bands[0].bandName }}</td>
                      <td>{{ department.bands[0].inputSummary?.totalEmployees }}</td>
                      <td>{{ department.bands[0].inputSummary?.totalFixedCTC }}</td>
                      <td>{{ department.bands[0].inputSummary?.eligibleEmployees }}</td>
                      <td>{{ department.bands[0].inputSummary?.eligibleEmployeesFixedCTC }}</td>
                      <td>{{ department.bands[0].inputSummary?.overallVariablePayBonusBudget }}</td>
                      <td>{{ department.bands[0].inputSummary?.variablePayBonusAmount }}</td>
                      <td>{{ department.bands[0].inputSummary?.variance }}</td>
                      <td>{{ department.bands[0].inputSummary?.variancePercentage }}</td>
                    </tr>
                    <ng-container *ngFor="let band of department.bands.slice(1)">
                      <tr>
                        <td>{{ band.bandName }}</td>
                        <td>{{ band.inputSummary?.totalEmployees }}</td>
                        <td>{{ band.inputSummary?.totalFixedCTC }}</td>
                        <td>{{ band.inputSummary?.eligibleEmployees}}</td>
                        <td>{{ band.inputSummary?.eligibleEmployeesFixedCTC }}</td>
                        <td>{{ band.inputSummary?.overallVariablePayBonusBudget }}</td>
                        <td>{{ band.inputSummary?.variablePayBonusAmount }}</td>
                        <td>{{ band.inputSummary?.variance }}</td>
                        <td>{{ band.inputSummary?.variancePercentage }}</td>
                      </tr>
                    </ng-container>

                    <tr class="Increment-Summary-Band-Total">
                      <td colspan="1">Total</td>
                      <td>
                        <!-- {{ department.totalEmployees }} -->
                      </td>
                      <td>{{ department.totalFixedCTCpa }}</td>
                      <td>{{ department.totalEmployees }}</td>
                      <td>{{ department.deptEligibleEmpFixedCtc }}</td>
                      <td>{{ department.deptVPBonusBudget }}</td>
                      <td>{{ department.variablePayBonusAmount }}</td>
                      <td>{{ department.variance }}</td>
                      <td>{{ department.variancePercentage }}</td>
                    </tr>
                  </ng-container>
                </tbody>

                <tfoot>
                  <tr class="Increment-summary-sticky-footer">
                    <td colspan="2">Grand Total</td>
                    <td>
                      <!-- {{ getGrandTotal('totalEmployees') }} -->
                    </td>
                    <td>{{gtFixedCTC}}</td>
                    <td>{{gtEligibleEmpCount}}</td>
                    <td>{{gtEligibleEmpFixedCTC}}</td>
                    <td>{{gtOverallVPBonusBudget}}</td>
                    <td>{{gtVPBonusActualAmount}}</td>
                    <td>{{gtVarience}}</td>
                    <td>{{gtVariencePer}}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </ion-col>
        </ion-row>
        <!-- <ion-row class="mb-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
            <ion-label class="fs-14 font_bold black_color">{{variableSummaryData.length}} entries</ion-label>
          </ion-col>
        </ion-row> -->
      </div>
    </div>

    <!-- -------------------------------------- Variable Pay Report -------------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Variable Pay Report'">
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex">
            <button type="button" (click)="onClickVariablePayReportsActiveTab(true)"
              [ngClass]="{'activeVariablePayReportsTab' : activeVariablePayReportsTab}"
              class="borderRadiusRight tabsBtn center-content fs-14"><span class="displayContent">
                Eligible ({{totalEligibleCount||0}})</span></button>
            <button type="button" (click)="onClickVariablePayReportsActiveTab(false)"
              [ngClass]="{'activeVariablePayReportsTab' : !activeVariablePayReportsTab}"
              class="borderRadiusLeft tabsBtn center-content fs-14"><span class="displayContent">
                Non Eligible ({{totalNonEligibleCount||0}})</span></button>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChangeReport($event);getVPCurrentYearFrequeny()">
                <mat-option *ngFor="let item of companyYears" [value]="item.year">
                  {{ sharedService.transformYearToFyFormat(item.year) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select placeholder="Select Period" [(ngModel)]="frequencyPeriod"
                (selectionChange)="updateReportOptions($event)">
                <mat-option *ngFor="let month of setupFrequencyForReports" [value]="month">
                  {{ month }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select multiple placeholder="Select Department">
                <mat-option>All</mat-option>
                <mat-option>Sales</mat-option>
                <mat-option>Manufacturing</mat-option>
                <mat-option>Finance</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select multiple placeholder="Select Band">
                <mat-option>All</mat-option>
                <mat-option>Executive/A/1</mat-option>
                <mat-option>Managerial/B/2</mat-option>
                <mat-option>Leadership</mat-option>
              </mat-select>
            </mat-form-field> -->

            <!-- <mat-form-field class="w250 mat-height40 mat-input-style">
              <mat-select multiple placeholder="Select VP Category">
                <mat-option>Fixed VP Budget</mat-option>
                <mat-option>% of CTC</mat-option>
              </mat-select>
            </mat-form-field> -->


            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Department'" [settings]="dropdownSettings"
              [data]="getDepartmentsList" [(ngModel)]="selectedDepartment" (onSelect)="onSelectDepartment()"
              (onDeSelect)="onDeSelectDepartment()" (onSelectAll)="selectAllDepartment($event)"
              (onDeSelectAll)="onDeSelectAllDepartment()">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Band'" [settings]="dropdownSettings"
              [data]="getBandList" [(ngModel)]="selectedBand" (onSelect)="onSelectdBand()"
              (onDeSelect)="onDeSelectdBand()" (onSelectAll)="selectAllBand($event)"
              (onDeSelectAll)="onDeSelectAllBand()">
            </ng-multiselect-dropdown>

            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select VP Category'"
              [settings]="dropdownSettings" [data]="vpCategoryList" [(ngModel)]="vpCategory"
              (onSelect)="onSelectedCategory()" (onDeSelect)="onDeSelectedCategory()"
              (onSelectAll)="selectAllCategory($event)" (onDeSelectAll)="onDeSelectAllCategory()">
            </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <ng-multiselect-dropdown class="ml-5 w250" [placeholder]="'Select Rating'" [settings]="dropdownSettings"
              [data]="getRatingData" [(ngModel)]="selectedRating" (onSelect)="onSelectdRating()" (onDeSelect)="onDeSelectdRating()"
              (onSelectAll)="selectAllRating($event)" (onDeSelectAll)="onDeSelectAllRating()">
            </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>

      <div class="tableCardBox mt-15 mb-15">
        <ion-row>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex">
              <mat-form-field class="mat-height40 mat-input-style">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onSearchInput($event)">
              </mat-form-field>
              <span *ngIf="isVPInputSetupNotDone" class="regular fs-12 mt-10 ml-10" style="color: #E94848;">Setup not completed</span>
            </div>
          </ion-col>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
            <div class="d-flex float-right">
              <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadvpReportsExcelFile()">
                <span class="material-icons">download</span></button>
              <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                class="customMaterialIcon fs-14">
                <span class="material-icons">tune</span></button>

              <mat-menu #menu="matMenu">
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                    *ngFor="let item of variablePayInputTableHideShowAllData" class="mat-checkbox-style">
                    <mat-checkbox [(ngModel)]="item.isVisible" class="fs-12 font_semibold "
                      (change)="onSelectVariableInputHideShowCheckBox($event)" [checked]="item.isVisible" value="true"
                      (click)="$event.stopPropagation()" value=true>{{item.fieldName}}</mat-checkbox>
                  </ion-col>
                </ion-row>
              </mat-menu>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="p-5 mt-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">
              <!-- Eligible Input Table -->
              <table class="increment-tabs-table" *ngIf="activeVariablePayReportsTab" id="vpReportsEligibleTable">
                <thead>
                <tr>
                  <ng-container *ngFor="let item of variablePayInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{item.fieldName}}
                        <span class="material-icons cp ml-5 mt-3 fs-14"
                          (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                      </div>
                    </th>
                  </ng-container>
                </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementInputEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                            {{ employee.isEligible?'Yes':'No' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>

                          <!-- Additional Information -->
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')">
                            {{ employee.normalisationHhod }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HR normalization')">
                            {{ employee.normalisationHRMDCEO }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">{{totalEligibleTotalFixedCtcPM | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA | number:'1.2-2'}}</td>
                      <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Rating')"> </td>
                      <td *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                    </td>
                    <td *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">{{totalEligibleDaysPeriod | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">{{totalEligibleProtatedVB}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HR normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">{{totalEligibleVBAmount | number:'1.2-2'}}</td>
                  </tr>
                </tfoot>
              </table>

              <!-- Non Eligible Input Table -->

              <table class="increment-tabs-table" *ngIf="!activeVariablePayReportsTab" id="vpReportsNonEligibleTable">
                <thead>
                  <tr>
                    <ng-container *ngFor="let item of variablePayInputTableHideShowAllData; let i = index">
                      <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                          {{item.fieldName}}
                          <span class="material-icons cp ml-5 mt-3 fs-14"
                            (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementInputNonEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                            {{ employee.isEligible?'Yes':'No' }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>

                          <!-- Additional Information -->
                          <td
                            *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')">
                            {{ employee.normalisationHhod }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('HR normalization')">
                            {{ employee.normalisationHRMDCEO }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.f.')">{{totalEligibleTotalFixedCtcPM | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA | number:'1.2-2'}}</td>
                      <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                      <td *ngIf="getIncrementInputColumnVisibility('Final Rating')"> </td>
                      <td *ngIf="getIncrementInputColumnVisibility('Variable bonus category % age of CTC OR fixed budget')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                    </td>
                    <td *ngIf="getIncrementInputColumnVisibility('Days served in the period (Depending on review cycle)')">{{totalEligibleDaysPeriod | number:'1.2-2'}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('Prorated VB% / Amount')">{{totalEligibleProtatedVB}}</td>
                    <td *ngIf="getIncrementInputColumnVisibility('HOD normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('HR normalization')"></td>
                    <td *ngIf="getIncrementInputColumnVisibility('Final VB amount')">{{totalEligibleVBAmount | number:'1.2-2'}}</td>
                  </tr>
                </tfoot>
              </table>


              <!-- Report Eligible Employees -->
              <!-- <table class="increment-tabs-table" *ngIf="activeVariablePayReportsTab">
                <thead>
                  <ng-container *ngFor="let item of variablePayReportsTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{item.fieldName}}
                        <span class="material-icons cp ml-5 mt-3 fs-14"
                          (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                      </div>
                    </th>
                  </ng-container>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementReportsEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementReportsColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Eligible Emp.')">
                            {{ employee.isEligible?'Yes':'No' }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementReportsColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Actual Variable pay Bonus - % / amount')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>
                          <td
                            *ngIf="getIncrementReportsColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HOD normalization')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HR normalization')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="7">Total</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Eligible Emp.')">{{totalEligibleTotalFixedCtcPM}}
                    </td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA}}</td>
                    <td colspan="7"></td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget}}</td>
                    <td
                      *ngIf="getIncrementReportsColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                      {{totalEligibleActualVariablePayBonus}}</td>
                    <td
                      *ngIf="getIncrementReportsColumnVisibility('Days served in the period (Depending on review cycle)')">
                      {{totalEligibleDaysPeriod}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Prorated VB% / Amount')">
                      {{totalEligibleProtatedVB}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('HOD normalization')">
                      {{totalEligibleHODNoramlization}}
                    </td>
                    <td *ngIf="getIncrementReportsColumnVisibility('HR normalization')">
                      {{totalEligiblenormalisationHRMDCEO}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Final VB amount')">{{totalEligibleVBAmount}}</td>

                  </tr>
                </tfoot>
              </table> -->

              <!-- Report NonEligible Employees -->
              <!-- <table class="increment-tabs-table" *ngIf="!activeVariablePayReportsTab">
                <thead>
                  <ng-container *ngFor="let item of variablePayReportsTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                      <div class="verticle-center justify-content-space-between icon-style">
                        {{item.fieldName}}
                        <span class="material-icons cp ml-5 mt-3 fs-14"
                          (click)="updateVariablePayInputColumnVisibility(item,i)">visibility_off</span>
                      </div>
                    </th>
                  </ng-container>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementReportsNonEligibleTableData">
                    <ng-container *ngFor="let band of department.bands; let i = index">
                      <ng-container *ngFor="let employee of band.employees; let j = index">
                        <tr>
                          <td *ngIf="getIncrementReportsColumnVisibility('Department') && i === 0 && j === 0"
                            [attr.rowspan]="getTotalRowSpan(department.bands)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Band') && j === 0"
                            [attr.rowspan]="band.employees.length">
                            {{ band.bandName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Employee')">
                            {{ employee.employeeName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Manager')">
                            {{ employee.managerName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HOD')">
                            {{ employee.hodName }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Designation')">
                            {{ employee.designation }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('DOJ')">
                            {{ employee.employeeDOJ | date: 'dd/MM/yyyy' }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.f.')">
                            {{ employee.totalFixedCTCpm }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.a.')">
                            {{ employee.totalFixedCTCpa }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Eligible Emp.')">
                            <mat-form-field class="w150 mat-height40 mat-input-style">
                              <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                                (selectionChange)="onEditIncrementInputTableData(employee, employee.id)">
                                <mat-option [value]="true">Yes</mat-option>
                                <mat-option [value]="false">No</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Individual KPI + Competency Score')">
                            {{ employee.individualKPICompetencyScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Department Score (out of 100)')">
                            {{ employee.departmentScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Company Score (out of 100)')">
                            {{ employee.companyScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final Score')">
                            {{ employee.finalScore }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final Rating')">
                            {{ employee.finalRating ? employee.finalRating : null }}
                          </td>
                          <td
                            *ngIf="getIncrementReportsColumnVisibility('Variable bonus category % age of CTC OR fixed budget')">
                            {{ employee.vpBonusCategoryOfCTC_OR_FixedBudget }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Fixed budget value if applicable yearly')">
                            {{ employee.fixedBudgetValue }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Actual Variable pay Bonus - % / amount')">
                            {{ employee.actualVPBonusPercentAmount }}
                          </td>
                          <td
                            *ngIf="getIncrementReportsColumnVisibility('Days served in the period (Depending on review cycle)')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Prorated VB% / Amount')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HOD normalization')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('HR normalization')">
                            {{ employee.daysServed }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Prorated Variable pay amount')">
                            {{ employee.proratedVPPercentAmount }}
                          </td>
                          <td *ngIf="getIncrementReportsColumnVisibility('Final VB amount')">
                            {{ employee.finalVPAmount }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="7">Total</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Eligible Emp.')">{{totalEligibleTotalFixedCtcPM}}
                    </td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Total Fixed CTC p.a.')">
                      {{totalEligibleTotalFixedCtcPA}}</td>
                    <td colspan="7"></td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Fixed budget value if applicable yearly')">
                      {{totalEligibleFixedBudget}}</td>
                    <td
                      *ngIf="getIncrementReportsColumnVisibility('Actual Variable pay Bonus - % / amount (according to rating to %)')">
                      {{totalEligibleActualVariablePayBonus}}</td>
                    <td
                      *ngIf="getIncrementReportsColumnVisibility('Days served in the period (Depending on review cycle)')">
                      {{totalEligibleDaysPeriod}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Prorated VB% / Amount')">
                      {{totalEligibleProtatedVB}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('HOD normalization')">
                      {{totalEligibleHODNoramlization}}
                    </td>
                    <td *ngIf="getIncrementReportsColumnVisibility('HR normalization')">
                      {{totalEligiblenormalisationHRMDCEO}}</td>
                    <td *ngIf="getIncrementReportsColumnVisibility('Final VB amount')">{{totalEligibleVBAmount}}</td>

                  </tr>
                </tfoot>
              </table> -->
            </div>
          </ion-col>
        </ion-row>
        <!-- <ion-row class="mb-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
            <ion-label *ngIf="activeVariablePayReportsTab"
              class="fs-14 font_bold black_color">{{getIncrementReportsEligibleTableData.length}} entries</ion-label>
            <ion-label *ngIf="!activeVariablePayReportsTab"
              class="fs-14 font_bold black_color">{{getIncrementReportsNonEligibleTableData.length}} entries</ion-label>
          </ion-col>
        </ion-row> -->
      </div>
    </div>
  </ion-content>
<!-- </ng-template> -->